import PropTypes from 'prop-types';


export const GuavaPropTypes = {};

GuavaPropTypes.isFinite = (props, propName, componentName) => {
  const value = props[propName];

  if (value === null || value === undefined) {
    return null;
  }

  if (!Number.isFinite(+value)) {
    return new Error(`Invalid prop \`${propName}\` supplied to`
      + ` \`${componentName}\`. Should be something which can be parsed as a finite number.`
      + ` \`${value}\` passed. Validation failed.`);
  }
};

// Import helper for code completion
export default PropTypes;
